import {MomentInput} from "moment";
import React, {FunctionComponent} from "react";
import {Formatter, FormatterFormat} from "../../../utils/Formatter";
import {PropsWithOverwrite} from "../../../utils/input";
import Input, {InputProps} from "./Input";

export enum InputDateType {
    DATE = "date",
    DATETIME_LOCAL = "datetime-local",
    MONTH = "month"
}

type InputDateProps = PropsWithOverwrite<InputProps<string>, {
    type?: InputDateType;
    min?: MomentInput;
    max?: MomentInput;
}>;

const InputDate: FunctionComponent<InputDateProps> = ({type = InputDateType.DATE, min, max, ...inputAttr}) => {
    let dateFormat: FormatterFormat;

    switch (type) {
        case InputDateType.DATETIME_LOCAL:
            dateFormat = FormatterFormat.DATE_TIME_INPUT;
            break;
        case InputDateType.MONTH:
            dateFormat = FormatterFormat.MONTH_INPUT;
            break;
        default:
            dateFormat = FormatterFormat.DATE_INPUT;
    }

    return (
        <Input
            type={type}
            min={min ? Formatter.formatDate(min, dateFormat) : undefined}
            max={max ? Formatter.formatDate(max, dateFormat) : undefined}
            {...inputAttr}
        />
    );
};

export default InputDate;
